import BaseComponent from "../components/BaseComponent";
import {Panel, SplitCol, SplitLayout, View} from "@vkontakte/vkui";
import SaleDocs from "../saleDocs/SaleDocs";
import SaleDocForm from "../saleDocs/SaleDocForm";
import SaleDocFFCMonitoring from "../saleDocs/SaleDocFFCMonitoring";
import TakeAPhoto from "../components/TakeAPhoto";
import React from "react";
import {AdaptivityContext} from "../assets/constants";
import * as constants from "../assets/constants";

class FragmentReport_ffc extends BaseComponent {

    constructor(props) {
        super(props)
        const state = {
            saleDocsState: null,
            activePanelReportFFC: "report_ffc_saledocs_panel",
            current_doc: null,
        }

        this.state = {
            ...this.state,
            ...state
        }
    }

    receiveMessage = (event) => {

    }
    selectCurrentDoc = (item, is_club = false, is_monitoring = false) => {
        this.setState({current_doc: item})
        if (constants.AdaptivityContext.isMobile && !is_monitoring) {

            this.setState({activePanelReportFFC: "report_ffc_sale_doc_panel"})

        }
    }

    hideDoc = () => {

        this.setState({activePanelReportFFC: "report_ffc_saledocs_panel"})
    }

    render() {
        return <View activePanel={this.state.activePanelReportFFC} >

            <Panel id="report_ffc_saledocs_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <SaleDocs father={this} base_url={this.state.base_url}
                                  current_user={this.props.current_user}
                                  current_club={this.props.current_club}
                                  select_doc={this.selectCurrentDoc}/>
                    </SplitCol>
                    {AdaptivityContext.isMobile ? '' :
                        <SplitCol  style={{position: "sticky", top: "0px"}}>
                            <SaleDocForm
                                father={this} current_user={this.props.current_user}
                                current_club={this.props.current_club}
                                base_url={this.state.base_url}
                                current_doc={this.state.current_doc}
                                select_doc={this.selectCurrentDoc}
                            />
                        </SplitCol>}
                </SplitLayout>
            </Panel>
            <Panel id="report_ffc_sale_doc_panel">
                <SaleDocForm
                    father={this} current_user={this.props.current_user}
                    current_club={this.props.current_club}
                    base_url={this.state.base_url}
                    current_doc={this.state.current_doc}
                    show_back={true}
                    hideDoc={this.hideDoc}
                    select_doc={this.selectCurrentDoc}
                />
            </Panel>
            <Panel id="add_monitoring_ffc_sale_doc_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <SaleDocFFCMonitoring
                            father={this} current_user={this.props.current_user}
                            current_club={this.props.current_club}
                            base_url={this.state.base_url}
                            current_doc={this.state.current_doc}

                            back={
                                () => {
                                    this.setState({activePanelReportFFC: 'report_ffc_saledocs_panel'})
                                    setTimeout(() => window.postMessage({type: 'orderCreated'}), 700)
                                }
                            }
                            select_doc={this.selectCurrentDoc}
                        />
                    </SplitCol>
                    {AdaptivityContext.isMobile ? '' :
                        <SplitCol>
                            <SaleDocForm
                                father={this} current_user={this.props.current_user}
                                current_club={this.props.current_club}
                                base_url={this.state.base_url}
                                current_doc={this.state.current_doc}
                                select_doc={this.selectCurrentDoc}
                            />
                        </SplitCol>}
                </SplitLayout>
            </Panel>
            <Panel id="ffc_photo_panel">
                <SplitLayout>
                    <SplitCol width={"50%"}>
                        <TakeAPhoto
                            hidePhotos={() => this.setState({activePanelReportFFC: 'add_monitoring_ffc_sale_doc_panel'})}
                            url={this.state.url} openErrorNoty={this.openErrorNoty}/>
                    </SplitCol>
                </SplitLayout>
            </Panel>
        </View>
    }

}

export default FragmentReport_ffc

